import { RouteName, TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { Link, Typography } from '@optimus-web/core';

export const LocalCreatePolicyLinks = () => {
    const resolveRoute = useResolveRoute();
    return (
        <Typography textStyle="bodyMedium" variant="secondary" as="div">
            <LocalizedText
                textKey={TextKey.PolicyExceptionFormPolicyHelper}
                substitutes={{
                    a: (text) => (
                        <Link href={resolveRoute(RouteName.PolicyIndex)} target="_blank" rel="noreferrer">
                            {text}
                        </Link>
                    ),
                }}
            />
        </Typography>
    );
};
